module.exports = __webpack_public_path__ + "images/emoji/kiss.b3bca92a4847456336b9.png";